import { formatDate } from "@/lib/format";
import type { StatusTone } from "@/lib/widget-status";
import type { DBCustomerStatusRow } from "@/lib/db-types";

export type CustomerStatus = "warm" | "medium" | "cold";

export const CUSTOMER_STATUS_LABELS: Record<CustomerStatus, string> = {
  warm: "Varm",
  medium: "Medium",
  cold: "Kald",
};

/** Varm er positivt (reached), medium advarsel (near), kald utenfor mål (miss). Fargene kommer fra widget-status.ts. */
export function customerStatusTone(status: CustomerStatus): StatusTone {
  switch (status) {
    case "warm":
      return "reached";
    case "medium":
      return "near";
    default:
      return "miss";
  }
}

/** Sorteringsrekkefølge: varm først, så medium, så kald. */
export const CUSTOMER_STATUS_ORDER: Record<CustomerStatus, number> = { warm: 0, medium: 1, cold: 2 };

type ExplainInput = Pick<
  DBCustomerStatusRow,
  | "derived_status" | "effective_status" | "is_overridden" | "override_reason"
  | "override_until" | "override_by_name" | "last_purchase_at" | "cools_at" | "has_offers"
>;

/** Klartekst som forklarer hvorfor kunden har sin status. */
export function explainStatus(row: ExplainInput): string {
  if (row.is_overridden) {
    const who = row.override_by_name ? ` av ${row.override_by_name}` : "";
    const until = row.override_until ? ` til ${formatDate(row.override_until)}` : "";
    const reason = row.override_reason ? `: ${row.override_reason}` : "";
    return `Overstyrt${who}${until}${reason}`;
  }
  switch (row.derived_status) {
    case "warm":
      return `Varm: siste kjøp ${formatDate(row.last_purchase_at)}, kjølner ${formatDate(row.cools_at)}`;
    case "medium":
      if (row.last_purchase_at) {
        return `Medium: siste kjøp ${formatDate(row.last_purchase_at)}, kjølnet ${formatDate(row.cools_at)}`;
      }
      return "Medium: tilbud sendt, ingen vunnet";
    default:
      return "Kald: aldri fått tilbud";
  }
}
